import Axios from 'axios';
import { action, observable, computed } from 'mobx';
import without from 'lodash/without';
import Cookies from 'js-cookie';
import { BigNumber } from 'bignumber.js';
import { API } from '../config/api';
import { getDomain, getExchangeUrl } from '@/utils/location';
import { CURRENCY_LIST, CurrencyCode, CurrencyItem, LANG_LIST, LangCode, LangItem } from '@/config/const';

export interface StepRateTable {
  id: string;
  stepName: string;
  tradeVolume: number;
  makerFee: number;
  takerFee: number;
  levelRetentionDay: number;
  remark: string;
  createdTime: string;
  creator: string;
  updatedTime: string;
  updater: string;
}

export interface UserStepRate {
  discountLevel: number;
  makerFee: number;
  takerFee: number;
  levelReturnDay: number;
  totalTradeVolume: number;
  coinBasedTotalTradeVolume: number;
  nextLvTradeVolume: number;
  lackTradeVolume: number;
  ubasedTotalTradeVolume: number;
  specialType: boolean;
}

export interface ApplyResult {
  state: number; // 0 待审核 1审核通过 2审核拒绝
  tempLevel: number;
  tempLevelReturnDay: number;
}

export interface RecentTrade {
  statsTime: string;
  totalTradeVolume: number;
  ubasedTradeVolume: number;
  coinBasedTradeVolume: number;
}

export interface RecentTradeResult {
  page: number;
  ps: number;
  total: number;
  items: RecentTrade[];
}

export default class StepRate {
  @observable userStepRate: UserStepRate;

  @observable stepRateTable: StepRateTable[];

  @observable thirdPlatformList: string[];

  @observable userApplyResult: ApplyResult;

  @observable recentTradeResult: RecentTradeResult;

  constructor() {
    this.userStepRate = {} as UserStepRate;
    this.userApplyResult = {} as ApplyResult;
    this.stepRateTable = [] as StepRateTable[];
    this.thirdPlatformList = [];
    this.recentTradeResult = {} as RecentTradeResult;
  }

  @computed get currentLevel() {
    const { discountLevel } = this.userStepRate;
    const level = Number(discountLevel);
    const currentLevel =
      level < this.tabelList.length ? this.tabelList[level] : this.tabelList[this.tabelList.length - 1];

    return currentLevel || {};
  }

  @computed get isSpecialAccout() {
    return this.userStepRate.specialType;
  }

  @computed get levelList() {
    return this.stepRateTable.map(({ id, stepName }) => ({ id, stepName }));
  }

  @computed get tabelList() {
    return this.stepRateTable.map(({ id, stepName, tradeVolume, makerFee, takerFee }) => ({
      id,
      stepName,
      tradeVolume,
      makerFee,
      takerFee,
    }));
  }

  @action.bound
  async fetchStepRateTable() {
    const res: StepRateTable[] = await Axios.get(API.STEP_RATE_TABLE);

    this.stepRateTable = res;
  }

  @action.bound
  async fetchUserStepRate() {
    const res: UserStepRate = await Axios.get(API.USER_STEP_RATE);

    this.userStepRate = res;
  }

  @action.bound
  async fetchOtherPlatforms() {
    const res: string[] = await Axios.get(API.OTHER_PLATFORM);

    this.thirdPlatformList = res;
  }

  @action.bound
  async fetchUserApplyResult() {
    const res: ApplyResult = await Axios.get(API.USER_APPLY_RESULT);

    this.userApplyResult = res;
  }

  @action.bound
  async fetchRecentTradeResult(page?: number, pageSize?: number) {
    const res: RecentTradeResult = await Axios.get(`${API.RECENT_TRADE}?page=${page || 1}&size=${pageSize || 5}`);

    this.recentTradeResult = res;
  }
}
